import { EnvironmentConfig, S3Config } from 'src/components/context/AppContextModels';
import { getStageConfig } from 'src/components/fintech-ops/upgrade-medic/config';

// Helper function to resolve template variables with fallback values for localhost development
function resolveTemplateVar(templateValue: string, fallbackValue: string): string {
  const resolved = templateValue.includes('{{') ? fallbackValue : templateValue;
  return resolved;
}

// Resolve critical variables for localhost development
const resolvedRegion = resolveTemplateVar('us-west-2', 'us-west-2');
const resolvedStage = resolveTemplateVar('alpha', 'alpha');

/** Stage normalized for resource names — personal 'dev' stacks use 'alpha' shared resources */
export const NORMALIZED_STAGE = resolvedStage.toLowerCase() === 'dev' ? 'alpha' : resolvedStage.toLowerCase();

/** True in non-production stages (personal 'dev' desktops + shared 'alpha'). Use to gate
 *  developer-only affordances (e.g. the DEV_LDAP access override) so they never apply in beta/prod. */
export const IS_NON_PROD = ['dev', 'alpha'].includes(resolvedStage.toLowerCase());

// Environment variables
export const ENVIRONMENT_VARIABLES = Object.freeze<{ env: EnvironmentConfig }>({
  env: {
    Region: resolvedRegion,
    Stage: resolvedStage,
    CloudFrontProtocol: 'https',
    CloudFrontDomain: 'dar2i0uzxfy3w.cloudfront.net',
    CognitoUserPoolId: 'us-west-2_D6VvUWsrZ',
    CognitoIdentityPoolId: 'us-west-2:f6037eb4-644d-429c-ad8f-f440416a0f6c',
    AuthenticationType: 'apiKey',
    CognitoUserPoolWebClientId: '5sng7dqb0j8bpojejroh1aovjh',
    CognitoDomain: 'das-finsuite-application-alpha-v1.auth.us-west-2.amazoncognito.com',
    ApplicationDomain: 'https://aashnna.alpha.finsuite.device.finance.amazon.dev',
    AwsAccountId: '850882930567'
  }
});

// S3 configuration constants
export const S3_ENV_CONSTANTS = Object.freeze<{ ENVIRONMENT_VARIABLES: S3Config }>({
  ENVIRONMENT_VARIABLES: {
    Bucket: ENVIRONMENT_VARIABLES.env.Stage === 'dev' ? 'op-excellence-alpha' : `op-excellence-${ENVIRONMENT_VARIABLES.env.Stage}`,
    Prefix: 'oe-rpt-tables-data-export/'
  }
});

// FinTalk URL configuration
export const FINTALK_URLS = Object.freeze({
  PROD: 'https://fintalk.fgbs.amazon.dev/?SERVICE=DEVICES&SIDEBAR=CLOSED',
  GAMMA: 'https://gamma.fintalk.fgbs.amazon.dev/?SERVICE=DEVICES&SIDEBAR=CLOSED'
});

export const getUpgradeMedicConfig = () => {
  const cfg = getStageConfig();
  return {
    accountId: cfg.accountId,
    roleArn: cfg.roleArn,
    tableName: cfg.tables.resourceInventory,
    region: cfg.region
  };
};

export const PIPELINE_OE_DASHBOARD_ID_BY_STAGE: Record<string, string> = {
  alpha: '5b0328e3-54ec-43bc-808c-610de3a2e2bc',
  beta: 'b36e7a13-a61e-488a-9790-242d18726a84',
  prod: '0f3bc133-d051-4f85-85a6-524b41cb3ebd'
};
